import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a7caa7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "serviceStatusSearchWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "noResultsMsg"
}
const _hoisted_3 = {
  key: 1,
  class: "searchResults"
}
const _hoisted_4 = { class: "heading" }

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouteServiceStatus, RecentOrSuggestedSearchEntry } from '../../types';
import { Route } from '../../types/api';
import { ServiceStatusSearchBox, RouteItem } from '../../Molecules';
import { useServiceStatusStore } from '../../store';
import { mapRoutes, mapRouteToSuggestedSearchEntry } from '../../maps';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusSearch',
  props: {
    searchInputId: {},
    searchInputLabel: {},
    searchInputPlaceholder: {},
    searchClickAction: { type: Function },
    itemClickAction: { type: Function },
    selectRouteMapCallback: { type: Function },
    disabled: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ['updateSearchResults', 'updateMapRoute'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const searchValue = ref('');
const resultsText = ref('');
const searchSuggestions = ref<RecentOrSuggestedSearchEntry[]>();
const suggestionTitle = ref('Recent');
const showSearches = ref(false);
const searchInitiated = ref(false);
const isSearchFocus = ref(false);
const serviceStatusStore = useServiceStatusStore();
const searchResults = ref<RouteServiceStatus[]>();
const recentSearchList = ref<Array<string>>([]);
const placeholder = ref(props.searchInputPlaceholder);

const emit = __emit;

const showSearchResults = computed(() =>
  searchResults.value !== undefined
  && searchResults.value.length > 0
  && searchInitiated.value);

const getSuggestions = async () => {
  if (searchValue.value.length <= 2 && serviceStatusStore.recentSearches.length === 0) {
    showSearches.value = false;
    return;
  }

  if (isSearchFocus.value) {
    showSearches.value = true;
  }
  suggestionTitle.value = t('Recent');

  if (searchValue.value.length <= 2) {
    searchSuggestions.value = serviceStatusStore.recentSearches.map((item) => ({
      iconName: 'clock',
      ports: [{ name: item }],
    } as RecentOrSuggestedSearchEntry)) as RecentOrSuggestedSearchEntry[];
  } else {
    try {
      await serviceStatusStore.getRoutesSuggestion(searchValue.value);
      suggestionTitle.value = t('Select a route');
    } catch (e) {
      console.log('e', e);
    }
  }
};

const handleSearch = async (searchInput: string) => {
  try {
    searchInitiated.value = true;
    await serviceStatusStore.getSearchRouteStatuses(searchInput);
  } catch (e) {
    console.log('e', e);
  }

  if (props.searchClickAction) {
    props.searchClickAction(searchInput);
  }

  resultsText.value = searchInput;
  showSearches.value = false;
};

const onRouteItemClick = (serviceArray, index) => {
  props.itemClickAction(serviceArray, index);
};

const onClearSearch = () => {
  searchInitiated.value = false;
  showSearches.value = false;
  searchResults.value = undefined;
  emit('updateSearchResults', undefined);
  serviceStatusStore.clearSearchRouteStatuses();
  searchValue.value = '';
};

watch([searchValue], async () => {
  try {
    await getSuggestions();
  } catch (e) {
    console.log('e', e);
  }
});

watch(() => serviceStatusStore.queryResults, (newVal) => {
  if (newVal === undefined) {
    searchResults.value = undefined;
    emit('updateSearchResults', undefined);
  } else {
    // If search not initated by user then don't refresh (handles refetch issue)
    if (!searchInitiated.value) {
      return;
    }
    searchResults.value = newVal && newVal.routes?.length > 0
      ? newVal.routes.map(mapRoutes)
      : [];
    emit('updateSearchResults', searchResults.value);
  }

  if (searchResults.value) {
    const searchResultsExcludingFreight = searchResults.value
      .filter((route) => !route.ports.some((port) => port.isFreight || port.hideOnMap));

    if (searchResultsExcludingFreight.length > 0) {
      emit('updateMapRoute', searchResultsExcludingFreight);
    }
  }
});

watch(() => serviceStatusStore.routeSuggestion, (newVal) => {
  searchSuggestions.value = newVal ? newVal.routes.map(mapRouteToSuggestedSearchEntry)
    : undefined;
});

watch(() => serviceStatusStore.recentSearches, (recentSearches) => {
  recentSearchList.value = recentSearches;
});

watch(() => isSearchFocus.value, (isFocus) => {
  if (isFocus) {
    showSearches.value = true;
    placeholder.value = ' ';
    getSuggestions();
  } else {
    placeholder.value = props.searchInputPlaceholder
      ? props.searchInputPlaceholder : t('Service status search placeholder');
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ServiceStatusSearchBox), {
      "search-input-id": _ctx.searchInputId,
      "search-input-label": _ctx.searchInputLabel,
      placeholder: placeholder.value ? placeholder.value : _ctx.$t('Service status search placeholder'),
      suggestions: searchSuggestions.value,
      "suggestions-title": _ctx.$t(suggestionTitle.value),
      "show-searches": showSearches.value,
      disabled: _ctx.disabled,
      "show-route-map-button": true,
      "select-route-map-callback": _ctx.selectRouteMapCallback,
      "hide-search-btn": searchResults.value === undefined,
      onUpdateSearchValue: _cache[0] || (_cache[0] = (value) => searchValue.value = value),
      onClearSearchValue: onClearSearch,
      onSetShowSearches: _cache[1] || (_cache[1] = (value) => showSearches.value = value),
      onGetIsFocus: _cache[2] || (_cache[2] = (isFocus) => isSearchFocus.value = isFocus),
      onSearchClick: _cache[3] || (_cache[3] = () => handleSearch(searchValue.value))
    }, null, 8, ["search-input-id", "search-input-label", "placeholder", "suggestions", "suggestions-title", "show-searches", "disabled", "select-route-map-callback", "hide-search-btn"]),
    (searchResults.value !== undefined && searchResults.value.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('No search results message', [searchValue.value])), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "infoCard"),
    (showSearchResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Results for text', [resultsText.value])), 1),
            _renderSlot(_ctx.$slots, "statusKeyButton")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "routeItem"
            }, [
              _createVNode(_unref(RouteItem), {
                "destination-name": item.destinationName,
                ports: item.ports,
                status: item.status,
                "click-handler": () => onRouteItemClick(searchResults.value, index),
                "is-loading": _ctx.isLoading
              }, null, 8, ["destination-name", "ports", "status", "click-handler", "is-loading"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})